const EXACT_PAGE_TITLES = {
  login: 'Login',
  sso_login: 'Login',
  auth_signup: 'Criar conta',
  auth_confirmation: 'Confirmar conta',
  auth_verify_email: 'Verificar e-mail',
  auth_password_edit: 'Definir nova senha',
  auth_reset_password: 'Redefinir senha',
  home: 'Início',
  no_accounts: 'Sem contas',
  account_suspended: 'Conta suspensa',
  notifications_index: 'Notificações',
  aceleres_team_presence: 'Equipe online',
  aceleres_team_presence_history: 'Histórico da equipe',
  aceleres_carteirizacao: 'Carteirização',
  configuracoes_integracoes: 'Integrações',
  configuracoes_equipes: 'Equipes',
  configuracoes_usuarios: 'Usuários',
  configuracoes_novo_usuario: 'Novo usuário',
  configuracoes_perfil: 'Perfil',
  configuracoes_modelos_mensagens: 'Modelos de mensagens',
};

const PAGE_TITLE_GROUPS = [
  [/conversation|inbox_view/, 'Conversas'],
  [/^inbox_|settings_inbox|social_channels/, 'Caixas de entrada'],
  [/^contacts_/, 'Contatos'],
  [/^companies_/, 'Empresas'],
  [/^campaigns_/, 'Campanhas'],
  [/^portals_/, 'Central de ajuda'],
  [/team|settings_teams/, 'Equipes'],
  [/assignment_policy|capacity_policy/, 'Distribuição'],
  [/agent/, 'Agentes'],
  [/label/, 'Marcadores'],
  [/canned/, 'Respostas prontas'],
  [/automation/, 'Automações'],
  [/attribute/, 'Atributos'],
  [/integration|settings_applications/, 'Integrações'],
  [/profile/, 'Perfil'],
  [/security|audit/, 'Segurança'],
  [/billing/, 'Faturamento'],
  [/macro/, 'Macros'],
  [/sla_/, 'Políticas de SLA'],
  [/captain|aurora/, 'Aurora'],
  [/workflow/, 'Fluxos de conversa'],
  [/team_numbers/, 'Números da equipe'],
  [/settings_/, 'Configurações'],
];

export const resolvePageTitle = route => {
  const routeName = String(route?.name || '');
  const pageTitle =
    route?.meta?.pageTitle ||
    EXACT_PAGE_TITLES[routeName] ||
    PAGE_TITLE_GROUPS.find(([pattern]) => pattern.test(routeName))?.[1];

  return pageTitle ? `Zoraxy - ${pageTitle}` : 'Zoraxy';
};

export const updatePageTitle = route => {
  document.title = resolvePageTitle(route);
};
